import { VStack } from '@chakra-ui/react'

import SessionCard from './SessionCard'
import TimelineDots from './TimelineDots'
import type { SeriesHomeScheduleSessionDetails } from './types'

export default function SessionCardList({
  sessions,
  isUserRegisteredLearner,
  openExcusedAbsenceModal,
  openReflectionModal,
  isDialogue,
}: {
  sessions: SeriesHomeScheduleSessionDetails[]
  isUserRegisteredLearner: boolean
  openExcusedAbsenceModal: (sessionId?: number) => void
  openReflectionModal: (sessionId: number) => Promise<void>
  isDialogue: boolean
}) {
  return (
    <VStack position="relative" alignItems="stretch" spacing="24px">
      <TimelineDots />
      {sessions.map((session, i) => (
        <SessionCard
          key={session.positionInSeries}
          session={session}
          isUserRegisteredLearner={isUserRegisteredLearner}
          openExcusedAbsenceModal={() => openExcusedAbsenceModal(session.id)}
          openReflectionModal={() => openReflectionModal(session.id)}
          isDialogue={isDialogue}
          isLastCard={i === sessions.length - 1}
        />
      ))}
    </VStack>
  )
}
